module.exports = "../images/smallmouth-bass-fishing-ontario@2x.jpg?v=87bfb12";